import { render, staticRenderFns } from "./UservisitReport.vue?vue&type=template&id=66715a0e"
import script from "./UservisitReport.vue?vue&type=script&lang=js"
export * from "./UservisitReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports